export enum VisitSalesItemAttributesName {
  PrescribedProduct = 'Prescribed Product:',
  ExpiresBy = 'Expiration:',
  Quantity = 'QTY:',
  Refills = 'Refills:',
  Notes = 'Notes:',
  UnitOfMeasure = 'Unit of Measure:',
  Dose = 'Dose:',
  Frequency = 'Frequency:',
  Instructions = 'Instructions:',
}
